import { render, staticRenderFns } from "./TiedostopankkiHallitus.vue?vue&type=template&id=502c22ca&scoped=true"
import script from "./TiedostopankkiHallitus.vue?vue&type=script&lang=js"
export * from "./TiedostopankkiHallitus.vue?vue&type=script&lang=js"
import style0 from "./TiedostopankkiHallitus.vue?vue&type=style&index=0&id=502c22ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502c22ca",
  null
  
)

export default component.exports